var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"transparent","min-height":"unset"},attrs:{"id":"app"}},[_c('link',{attrs:{"href":"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900|Material+Icons","rel":"”stylesheet”"}}),_vm._v(" "),_c('link',{attrs:{"href":"https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css","rel":"stylesheet"}}),_vm._v(" "),_c('RealShrineLayout')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e95179da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 691
// module chunks = 0